import * as React from 'react';
import { useHover } from '@react-aria/interactions';
import { PolymorphicRef } from '../../../utils/PolymorphicTypes';
import { CircleButtonProps, CircleButtonComponent } from './CircleButtonTypes';
import { useCircleButtonTheme } from '../../../themes';
import { CircleButtonInputValidationError } from './CircleButtonErrors';
import { variantStyleObject } from './CircleButtonStyleObject';
import { Icon } from '../../index';

export const CircleButton: CircleButtonComponent = React.forwardRef(
  <C extends React.ElementType = 'button'>({
  as,
  colorStyle='default',
  disabled=false,
  icon='account',
  id,
  onClick,
  selected=false,
  size='sm',
  ...htmlProps
}:CircleButtonProps<C>, 
ref?:PolymorphicRef<C>) => {

  const isLink = as && ((typeof as === 'string' && as === 'a')
  || (typeof as === 'object')) ? true : false;

  const Component = (disabled && isLink) ? 'div' : (as || 'button');

  let { hoverProps, isHovered } = useHover({});

  const showActiveStyle = disabled ? false : isHovered;

  const _iconColor = selected ? '$color-primary-a2' : (showActiveStyle ? variantStyleObject[colorStyle]['active']?.iconColor : variantStyleObject[colorStyle]['inactive']?.iconColor); 

  const { circleButtonTheme } = useCircleButtonTheme(); 

  const circleButtonClasses = [
    circleButtonTheme['bsw-circle-button'],
    circleButtonTheme[`bsw-circle-button-color--${colorStyle}`],
    circleButtonTheme[`bsw-circle-button-size--${size}`],
    disabled ? circleButtonTheme['bsw-circle-button--disabled'] : '',
    selected ? circleButtonTheme['bsw-circle-button--selected'] : '',
    !disabled && isHovered ? circleButtonTheme['bsw-circle-button--hover'] : ''
  ].join(' ');

    // Include disabled for elements that it is a valid attribute
    const _showDisabledAttr=(!as || (as && typeof as === 'string' && (as === 'button' || as === 'input'))) ? disabled : undefined;

    const defaultProps = {
        ...htmlProps,
        ...hoverProps,
        onClick:onClick,
    }

    const componentProps = disabled ? {} : defaultProps;

  return (
    <Component
      {...componentProps}
      className={circleButtonClasses}
      disabled={_showDisabledAttr}
      id={id}
      ref={ref}
      type={htmlProps?.type || (!as || (typeof as === 'string' && as === 'button') ? 'button' : undefined)}
    >
          <Icon
              name={icon}
              size="medium"
              color={_iconColor}
              disabled={disabled}
          />
    </Component>
  );
});
